import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class MonthEndStockItemReferenceService extends BaseReferenceService {
  constructor() {
    super('MonthEndStockItemReference');
  }
}
